const delayed = (ms, fn) => setTimeout(fn, ms);

export default delayed;
